export function projectStatusHumanized(_index) {
  const list = ["New", "In Progress", "On Review", "Completed"]

  return list[_index];
}

export default projectStatusHumanized;
